<template>
  <flex
    direction="column"
    justify="center"
    class="login-form"
  >
    <flex
      justify="between"
      class="close-icon-box"
    >
      <i
        v-if="loginType !== 'phone'"
        class="el-icon-arrow-left option-icon"
        @click="changeLoginType('phone')"
      />
      <i v-else />
      <i
        class="el-icon-close option-icon"
        @click="$emit('close')"
      />
    </flex>
    <el-form
      v-show="loginType === 'phone' && !boundWeixinStatus"
      ref="loginForm"
      :model="loginForm"
      :rules="rules"
      label-width="0px"
    >
      <el-form-item prop="phone">
        <el-input
          v-model="loginForm.phone"
          placeholder="请输入手机号"
        >
          <el-select
            slot="prepend"
            v-model="loginForm.phoneType"
            placeholder="请选择"
            style="width: 80px;"
          >
            <el-option
              label="+86"
              value="+86"
            />
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item prop="slideStatus">
        <slider-verify @success="handleSuccess" />
      </el-form-item>
      <el-form-item prop="code">
        <flex justify="between">
          <el-input
            v-model="loginForm.code"
            placeholder="请输入短信验证码"
            @keyup.enter.native="submitLogin"
          />
          <div
            v-loading="codeLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            class="verify-loading"
            @click="getcode"
          >
            <span>获取验证码</span>
            <div
              v-show="waitStatus"
              class="cutdown-text"
            >
              {{ cutdown }}
            </div>
          </div>
        </flex>
      </el-form-item>
      <!-- <el-form-item>
        <flex
          justify="between">
          <el-checkbox
            v-model="loginBynext">
            下次自动登录
          </el-checkbox>
          <span class="forget-password">
            忘记密码
          </span>
        </flex>
      </el-form-item> -->
      <el-form-item>
        <el-button
          :loading="loginLoading"
          style="width: 100%"
          type="primary"
          @click="submitLogin"
        >
          {{ bindingStatus ? '绑定手机号并登录' : '登录/注册' }}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- <div
      v-show="loginType === 'wx'"
      class="wx-login">
      <iframe
        :src="wxLoginUrl"
        style="width: 300px;height: 400px"
        frameborder="0"
        scrolling="no"
      />
    </div> -->
    <wxlogin
      v-show="loginType === 'wx' || boundWeixinStatus"
      :scope="'snsapi_login'"
      :redirect_uri="wxRedirectUri"
      :href="wxCSSfiLe"
      appid="wx5d42aa7712b8d498"
      rel="external nofollow"
      style="text-align: center"
    />
    <flex
      v-if="(!bindingStatus && !boundWeixinStatus) && loginType === 'phone'"
      justify="center"
      class="third-login-type-wrapper"
    >
      <svg-icon
        icon-class="wx"
        class="login-type-icon wx"
        @click.native="changeLoginType('wx')"
      />
      <!-- <svg-icon
          icon-class="qq"
          class="login-type-icon qq" /> -->
    </flex>
  </flex>
</template>

<script>
import SliderVerify from '@/components/Common/SliderVerify'
import wxlogin from 'vue-wxlogin'
import { setToken } from '@/utils/auth'
import { mapGetters } from 'vuex'
import * as api from '@/api/user'

export default {
  components: {
    SliderVerify,
    wxlogin
  },
  props: {
    boundWeixinStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validatestatus = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请拖动滑块完成验证'))
      } else {
        callback()
      }
    }
    return {
      loginType: 'phone', // 登录方式
      loginForm: {
        phone: '', // 手机号
        phoneType: '+86', // 手机类型
        slideStatus: false, // 滑动验证
        code: '' // 验证码
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[123456789]))\d{8}$/,
            message: '请填写正确的手机号',
            trigger: 'blur'
          }
        ],
        slideStatus: [
          {
            require: true,
            validator: validatestatus,
            trigger: 'change'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      loginBynext: true, // 下次自动登录
      codeLoading: false, // 验证码加载
      waitStatus: false, // 验证码冷却状态
      timer: null, // 定时器
      cutdown: 59, // 验证码cd
      loginLoading: false,
      openId: '',
      thirdLoginType: '', // 第三方登录的方式
      bindingStatus: false // 绑定手机
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    wxCSSfiLe () {
      return `${window.origin}/static/css/wxlogin.css`
    },
    wxRedirectUri () {
      if (this.boundWeixinStatus) {
        // eslint-disable-next-line no-undef
        return encodeURIComponent(_SELF_API_ + 'wx-bounde')
      } else {
        // eslint-disable-next-line no-undef
        return encodeURIComponent(_SELF_API_ + 'wx-login')
      }
    },
    wxLoginUrl () {
      return `https://open.weixin.qq.com/connect/qrconnect?appid=&scope=snsapi_login&redirect_uri=${this.wxRedirectUri}&state=&login_type=jssdk&style=black&self_redirect=true&href=`
    },
    // 微信code
    weixinCode () {
      return this.$route.query.code
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initThirdLogin()
    })
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    // 确认三方登陆
    initThirdLogin () {
      if (this.weixinCode) {
        if (this.$route.path.includes('login')) {
          api.thirdLogin({
            login_model: 'web',
            login_type: 'weixin',
            weixin_code: this.weixinCode
          }).then(res => {
            const data = res.result
            this.thirdLoginType = 'weixin'
            if (!data.bound_phone) {
              this.bindingStatus = true
              this.openId = data.openid // 微信登录返回的optenId
            } else {
              this.$store.commit('SET_USER_INFO', data)
              setToken(data.token)
              // 回到微信登录前的页面
              this.$emit('close')
              window.open(localStorage.getItem('last_url'), '_self')
              this.$emit('finish')
            }
          })
        } else {
          api.boundWeixin({
            weixin_code: this.weixinCode,
            user_id: this.userInfo.user_id
          }).finally(_ => {
            this.$store.dispatch('getUserInfo')
            this.$router.push('/person/personal-center/security')
          })
        }
      }
    },
    // 更改登录方式
    changeLoginType (type) {
      this.loginType = type
      localStorage.setItem('last_url', window.location.href || document.URL || window.location.toString())
    },
    // 滑动验证成功
    handleSuccess () {
      this.loginForm.slideStatus = true
      this.$refs.loginForm.validateField('slideStatus')
    },
    // 获取验证码
    getcode () {
      if (this.waitStatus) return
      this.$refs.loginForm.validateField('phone', valid => {
        if (!valid) {
          this.codeLoading = true
          api.getCodeByPhone({
            phone: this.loginForm.phone
          }).then(res => {
            this.codeLoading = false
            this.waitStatus = true
            this.timer = setInterval(() => {
              --this.cutdown
              if (this.cutdown === 0) {
                this.waitStatus = false
                this.cutdown = 59
                clearInterval(this.timer)
              }
            }, 1000)
          })
        }
      })
    },
    // 提交表单
    submitLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true
          let params = {
            ...this.loginForm
          }
          delete params.phoneType
          delete params.slideStatus
          if (this.bindingStatus) {
            params.openid = this.openId
            params.loginType = this.thirdLoginType
          }
          let funcName = this.bindingStatus ? 'boundPhone' : 'loginByPhoneAndCode'
          api[funcName](params).then(res => {
            let userInfo = res.result || {}
            this.$store.commit('SET_USER_INFO', userInfo)
            setToken(userInfo.token)
            // localStorage.setItem('userInfo', JSON.stringify(userInfo))
            if (this.bindingStatus) {
              // this.$router.push(this.$route.path)
              // // 回到微信登录前的页面
              window.open(localStorage.getItem('last_url'), '_self')
            }
            this.$emit('finish')
          }).finally(_ => {
            this.loginLoading = false
          })
        }
      })
    },
    // 绑定第三登录账号
    boundThirdAccount (userInfo) {
      if (this.thirdLoginType === 'weixin') {
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-form
  width 100%
  padding 10px
  box-sizing border-box
.close-icon-box
  margin-bottom 20px
  .option-icon
    cursor pointer
    font-size 20px
    color #999
    &:hover
      color #bd2124
.form-title
  text-align center
  font-size 20px
  margin-bottom 40px
.forget-password
  cursor pointer
  transition all 0.2s
  &:hover
    color #BD2124
.verify-loading
  flex none
.third-login-type-wrapper
  position relative
  margin-top 30px
  padding-top 30px
  font-size 43px
  color #DDDDDD
  border-top 1px solid #CCCCCC
  &:before
    position absolute
    top -8px
    content '第三方账号登录'
    color #A2A2A2
    font-size 14px
    padding 0px 14px
    background #fff
.wx-login
  text-align center
.login-type-icon
  cursor pointer
  margin 0px 10px
  &.wx:hover
    color #28C445
  &.qq:hover
    color #30A5DD
</style>

<style lang="stylus">
.qrcode
  width 90%
</style>
